import { Directive, inject, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { UiPageChromeService } from './page-chrome.service';

/**
 * Declara los filtros de la segunda fila de la barra de título.
 * Solo se muestran cuando la ruta usa `titleBarMode: 'report'`.
 *
 * @example
 * ```html
 * <ng-template uiPageTitleBarRow>
 *   <ui-select placeholder="Cuentas de orden" [options]="options" />
 * </ng-template>
 * ```
 */
@Directive({
  selector: 'ng-template[uiPageTitleBarRow]',
})
export class UiPageTitleBarRowDirective implements OnInit, OnDestroy {
  private readonly template = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly chrome = inject(UiPageChromeService);

  ngOnInit(): void {
    this.chrome.registerTitleBarRow(this.template);
  }

  ngOnDestroy(): void {
    this.chrome.releaseTitleBarRow(this.template);
  }
}
